import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  ProductActivationSettingTranslationInput
} from "../../types/globalTypes";
import TranslationsProductActivationSettingPage, {
  fieldNames
} from "../components/TranslationsProductActivationSettingPage";
import { TypedUpdateProductActivationSettingTranslations } from "../mutations";
import { TypedProductActivationSettingDetails } from "../queries";
import { UpdateProductActivationSettingTranslations } from "../types/UpdateProductActivationSettingTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsProductActivationSettingQueryParams {
  activeField: string;
}
export interface TranslationsProductActivationSettingProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsProductActivationSettingQueryParams;
}

const TranslationsProductActivationSetting: React.FC<TranslationsProductActivationSettingProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateProductActivationSettingTranslations) => {
    if (data.productActivationSettingTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedProductActivationSettingDetails
      variables={{ id, language: languageCode }}
    >
      {activationSettingDetails => (
        <TypedUpdateProductActivationSettingTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: ProductActivationSettingTranslationInput = {};

              if (field === fieldNames.activationPcTitle) {
                input.activationPcTitle = data;
              } else if (field === fieldNames.activationPcContent) {
                input.activationPcContent = data;
              } else if (field === fieldNames.activationPcSuccessedTitle) {
                input.activationPcSuccessedTitle = data;
              } else if (field === fieldNames.activationPcSuccessedContent) {
                input.activationPcSuccessedContent = data;
              } else if (field === fieldNames.activationMbTitle) {
                input.activationMbTitle = data;
              } else if (field === fieldNames.activationMbContent) {
                input.activationMbContent = data;
              } else if (field === fieldNames.activationMbSuccessedTitle) {
                input.activationMbSuccessedTitle = data;
              } else if (field === fieldNames.activationMbSuccessedContent) {
                input.activationMbSuccessedContent = data;
              } else if (field === fieldNames.serialNumberPcContent) {
                input.serialNumberPcContent = data;
              } else if (field === fieldNames.serialNumberMbContent) {
                input.serialNumberMbContent = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsProductActivationSettingPage
                activeField={params.activeField}
                disabled={
                  activationSettingDetails.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.loginPopup, id)
                  )
                }
                onSubmit={handleSubmit}
                setting={maybe(
                  () =>
                    activationSettingDetails.data.productActivationSettingById
                )}
              />
            );
          }}
        </TypedUpdateProductActivationSettingTranslations>
      )}
    </TypedProductActivationSettingDetails>
  );
};
TranslationsProductActivationSetting.displayName =
  "TranslationsProductActivationSetting";
export default TranslationsProductActivationSetting;
